module.exports = __webpack_public_path__ + "static/media/CurieBanner.d4132dee.png";